<template>
    <div class="bottombg">
        <div class="bottom">
          <div class="w1200">
              <div class="left">
                  <div class="btlogo">
                    <img :src="logo" alt="">
                  </div>
                  <ul class="btnav">
                      <li>
                          <a href="javascript:;" class="a1">{{language[languagetype].about}}</a>
                          <router-link :to="{name:'about'}" class="a2">{{language[languagetype].company}}</router-link>
                          <router-link :to="{name:'service'}" class="a2">{{language[languagetype].service}}</router-link>
                          <router-link :to="{name:'contact'}" class="a2">{{language[languagetype].contact}}</router-link>
                      </li>
                      <li>
                          <a href="javascript:;" class="a1">{{language[languagetype].onlineservice}}</a>
                          <a href="javascript:;" class="a2" @click="trackpagebtn">{{language[languagetype].trackpage}}</a>
                          <a href="javascript:;" class="a2" @click="orderbtn">{{language[languagetype].order}}</a>
                      </li>
                      <li>
                          <router-link :to="{name:'newslist',params:{id: 1}}" class="a1">{{language[languagetype].news}}</router-link>
                          <router-link v-for="(classl,index) in classs" :to="{name:'newslist',params:{id: classl.id}}" :key="index" class="a2">{{classl.title}}</router-link>
                      </li>
                      <li>
                          <a href="javascript:;" class="a1" @click="downpagepage">{{language[languagetype].downtitle}}</a>
                      </li>
                  </ul>
              </div>
              <div class="right">
                  <div class="bttitle">{{language[languagetype].contact}}</div>
                  <div class="bttitle2">
                    {{bttile}}
                  </div>
                  <span>
                    {{language[languagetype].iphone}}：{{iphone}}<br>
                    {{language[languagetype].address}}：{{address}}<br>
                    {{language[languagetype].code}}
                  </span>
                  <div class="weixin">
                      <img v-for="(img,index) in imgs" :key="index" :src="img" alt="" >
                  </div>
              </div>
          </div>
      </div>
      <div class="footer">
          <a href="https://beian.miit.gov.cn/" target="_blank">{{ipc}}</a>
      </div>
      <toast ref="toasttext"></toast>
    </div>
</template>

<script>
import Fetch from '../js/ajaxa'
import toast from '../components/taast/toast'
let languagetext = require('../js/index.json')
export default {
  name: 'index',
  data () {
    return {
      classs: [],
      iphone: '',
      address: '',
      imgs: [],
      ipc: '',
      bttile: '',
      lang: 1,
      username: '',
      language: {},
      languagetype: 'cn',
      logo: ''
    }
  },
  methods: {
    trackpagebtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'trackpage'})
    },
    orderbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'order'})
    },
    downpagepage: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'download'})
    }
  },
  created () {
    const that = this
    that.language = languagetext
    that.username = JSON.parse(localStorage.getItem('username'))
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
  },
  beforeCreate () {
    const that = this
    Fetch.post('Api/config', {
    }).then((res) => {
      that.bttile = res.title
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/foot', {
    }).then((res) => {
      that.classs = res.classify
      that.iphone = res.contact.number
      that.address = res.contact.address
      that.imgs = res.contact.codes
      that.ipc = res.icp
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/config', {
    }).then((res) => {
      that.logo = res.image
    }).catch(err => {
      console.log(err)
    })
  },
  components: {
    toast
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bottombg{height: 402px;}
    .bottom{height: 351px;overflow: hidden;background-color: #21212a;}
    .bottom .left{width: 530px;float: left;height: 341px;}
    .bottom .left .btlogo{width: 168px;height: 70px;margin-top: 45px;overflow: hidden;display: flex;align-items: center;}
    .bottom .left .btlogo img{width: auto;height: auto;max-width: 100%;max-height: 100%;}
    .bottom .left .btnav{width: 100%;height: auto;overflow: hidden;margin-top: 19px;}
    .bottom .left .btnav li{min-width: 132px;height: auto;float: left;}
    .bottom .left .btnav li a{text-decoration: none;}
    .bottom .left .btnav li .a1{display: block;line-height: 26px;height: 26px;margin-bottom: 19px;font-size: 16px;color: #fff;}
    .bottom .left .btnav li .a2{display: block;line-height: 25px;height: 25px;margin-bottom: 7px;font-size: 14px;color: #AFAFBF;}
    .bottom .right{width: 375px;float: right;overflow: hidden;}
    .bottom .right .bttitle{height: 30px;width: 100%;line-height: 30px;margin-top: 71px;text-indent: 36px;font-size: 20px;color: #fff;font-weight: bold;background:url("../assets/bticon.png") 0 center no-repeat;}
    .bottom .right .bttitle2{width: 100%;height: 26px;line-height: 26px;color: #fff;font-size: 16px;margin-top: 11px;}
    .bottom .right span{width: 100%;display: block;line-height: 32px;font-size: 14px;color: #afafbf;}
    .bottom .right .weixin{width: 100%;height: auto;}
    .bottom .right .weixin img{width: 75px;height: 75px;float: left;margin-right: 10px;}
    .footer{height: 51px;line-height: 51px;text-align: center;background-color: #17181e;color: #4d4d59;}
    .footer a{color: #4d4d59;}
</style>



// WEBPACK FOOTER //
// src/page/footer.vue